import { Link } from "react-router-dom";
import ProductThumb from "@/components/ProductThumb.jsx";
import ProductCatalogRatingBadge from "@/components/ProductCatalogRatingBadge.jsx";
import { NOUVEAUTES_ROUTE, ARRIVES_ROUTE } from "@/utils/constants.js";
import "./product-highlight-strip.css";

const META = {
    new: {
        title: "Nouveaux articles",
        className: "product-highlight-strip--new",
        viewAllTo: NOUVEAUTES_ROUTE
    },
    restocked: {
        title: "Articles restockés",
        className: "product-highlight-strip--restocked",
        viewAllTo: ARRIVES_ROUTE
    }
};

/**
 * One horizontal, scrollable highlight row (~80% catalogue card size; no price/category).
 * @param {{ kind: "new" | "restocked", products: object[] }} props
 */
export default function ProductHighlightStrip({ kind, products }) {
    const meta = META[kind] || META.new;
    if (!products?.length) {
        return null;
    }

    return (
        <section
            className={`product-highlight-strip ${meta.className}`}
            aria-label={meta.title}
        >
            <header className="product-highlight-strip__header">
                <div className="product-highlight-strip__heading">
                    {meta.badge ? (
                        <span className="product-highlight-strip__badge">{meta.badge}</span>
                    ) : null}
                    <h2 className="product-highlight-strip__title">{meta.title}</h2>
                </div>
                <Link to={meta.viewAllTo} className="product-highlight-strip__view-all">
                    Voir tout
                </Link>
            </header>
            <div className="product-highlight-strip__scroller" tabIndex={0}>
                {products.map((product) => (
                    <a
                        key={product.id}
                        href={`/product/${product.id}`}
                        className="product-highlight-strip-card"
                    >
                        <div className="product-highlight-strip-card__image">
                            <ProductCatalogRatingBadge averageGrade={product.averageGrade} />
                            <ProductThumb
                                fileId={product.photoIds?.[0] || product.photoId}
                                alt={product.title}
                                placeholder={product.title?.[0] || "P"}
                            />
                        </div>
                        <h3 className="product-highlight-strip-card__title">{product.title}</h3>
                    </a>
                ))}
            </div>
        </section>
    );
}
